export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-paypal-850f914162e5af8dbf66d94ba12a9711.svg";